/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { forwardRef, useEffect, useState } from "react";
import ReactPlayer from "react-player/lazy";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { Box } from "@mui/material";
import { findDOMNode } from "react-dom";
import screenfull from "screenfull";
import useSWRMutation from "swr/mutation";

import {
  getPlayerState,
  setDuration,
  setFullscreenFunc,
  setLoadedPercent,
  setMinimizePlayer,
  setMinimizePlayerBackUrl,
  setPlayedPercent,
  setPlaying,
  setTopicData,
  setUrl,
  setVideoLandscape,
  setVoiceOnly,
} from "../../../redux/features/playerSlice";
import { fetcherPost } from "../../../services/fetcher";
import { getSettingState } from "../../../redux/features/settingSlice";

const Player = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const {
    playing,
    playedPercent,
    voiceOnly,
    url,
    duration,
    playList,
    topicData,
    fullscreenFunc,
    playbackRate,
    minimizePlayerBackUrl,
  } = useSelector(getPlayerState);
  const { userData } = useSelector(getSettingState);
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const [videoWidth, setVideoWidth] = useState(null);
  const [videoHeight, setVideoHeight] = useState(null);
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const reqCon = !!topicData?.next_topic;

  const [pip, setPip] = useState(false);

  const [controls, setControls] = useState(false);

  const [light, setLight] = useState(false);

  const [volume, setVolume] = useState(1);

  const [muted, setMuted] = useState(false);

  const [loop, setLoop] = useState(false);

  // const [playbackRate, setPlaybackRate] = useState(1.0);

  const nextTopic = playList.filter(
    (e) =>
      e.pk ===
      (reqCon ? topicData?.next_topic?.pk : topicData?.next_converse?.pk)
  );

  const { trigger } = useSWRMutation(
    () => {
      if (!topicData || !userData) {
        return null;
      }
      return [
        `${process.env.REACT_APP_API}/content/log-play/${
          topicData.next_topic ? "topic" : "converse"
        }/${topicData.pk}/`,
        tokenStorage,
      ];
    },

    fetcherPost
  );
  const { trigger: viewed } = useSWRMutation(
    () => {
      if (!topicData || !userData) {
        return null;
      }
      return [
        `${process.env.REACT_APP_API}/content/viewed/${
          topicData.next_topic ? "topic" : "converse"
        }/${topicData.pk}/`,
        tokenStorage,
      ];
    },

    fetcherPost
  );

  // const handleStop = () => {
  //   setPlaying(false);
  // };

  // const handleToggleControls = () => {
  //   setControls(!controls);
  // };

  // const handleToggleLight = () => {
  //   setLight(!light);
  // };

  // const handleToggleLoop = () => {
  //   setLoop(!loop);
  // };

  // const handleVolumeChange = (e) => {
  //   setVolume(parseFloat(e.target.value));
  // };

  // const handleToggleMuted = () => {
  //   setMuted(!muted);
  // };

  // const handleSetPlaybackRate = (e) => {
  //   setPlaybackRate(parseFloat(e.target.value));
  // };

  // const handleTogglePIP = () => {
  //   setPip(!pip);
  // };

  // const handleEnablePIP = () => {
  //   setPip(true);
  // };

  // const handleDisablePIP = () => {
  //   setPip(false);
  // };

  // const handleOnPlaybackRateChange = (speed) => {
  //   setPlaybackRate(parseFloat(speed));
  // };

  // useEffect(() => {
  //   DetectPwa() === "pwa" && dispatch(setPlaying(true));
  //   // : dispatch(setPlaying(false));
  // }, []);

  const handlePlay = () => {
    dispatch(setPlaying(true));
  };

  const handlePause = () => {
    dispatch(setPlaying(false));
  };

  const handleClickFullscreen = () => {
    screenfull.request(findDOMNode(ref.current.player));
  };

  useEffect(() => {
    if (props.data && fullscreenFunc > 0) {
      handleClickFullscreen();
    }
    dispatch(setVideoLandscape(videoWidth > videoHeight));

    return () => {
      dispatch(setFullscreenFunc(0));
      dispatch(setVideoLandscape(false));
    };
  }, [props.data, fullscreenFunc, videoWidth, videoHeight]);

  const handleProgress = (state) => {
    if (playing) {
      dispatch(setPlayedPercent(state.played));
      dispatch(setLoadedPercent(state.loaded));
    }
  };

  useEffect(() => {
    ref.current?.seekTo(playedPercent * duration, "seconds");
  }, [duration]);

  const handleEnded = () => {
    if (urlParams[5] === "topics" && urlParams[6]) {
      if (props.data.next_topic) {
        navigate(
          `/table/${params.tableId}/${urlParams[3]}/${params.opinionId}/topics/${props.data.next_topic.pk}`,
          {
            replace: true,
          }
        );
      }
      if (props.data.next_converse) {
        navigate(
          `/table/${params.tableId}/${urlParams[3]}/${params.discussionId}/topics/${props.data.next_converse.pk}`,
          {
            replace: true,
          }
        );
      }
    } else {
      if (nextTopic[0]) {
        dispatch(setTopicData(nextTopic[0]));
        dispatch(setUrl(nextTopic[0].file));
        ref.current?.seekTo(0, "seconds");
        dispatch(setPlayedPercent(0));
        dispatch(
          setMinimizePlayerBackUrl(
            minimizePlayerBackUrl.slice(0, -String(topicData.pk).length) +
              nextTopic[0].pk
          )
        );
      } else {
        dispatch(setMinimizePlayer(false));
      }
    }

    trigger({ time_watched: 0 });
    viewed({ topic_id: topicData.pk });
    dispatch(setPlaying(true));
  };

  const handleDuration = (dur) => {
    dispatch(setDuration(dur));
  };

  const handleError = (e) => {
    // console.log("error", e);
  };

  useEffect(() => {
    if (props.data) {
      // if (props.data.file === url || props.data.extra === url) {
      // ref.current?.seekTo(playedPercent * duration, "seconds");
      // } else {
      ref.current?.seekTo(props.data.time_watched, "seconds");
      dispatch(setPlayedPercent(props.data.time_watched / props.data.duration));
    }
  }, [props.data]);

  useEffect(() => {
    if (props.data) {
      if (voiceOnly) {
        props.data.extra && dispatch(setUrl(props.data.extra));
      } else {
        props.data.file && dispatch(setUrl(props.data.file));
      }
    }
  }, [voiceOnly, props.data]);

  useEffect(() => {
    if (!props.data && urlParams[5] !== "topics") {
      ref.current?.seekTo(playedPercent * duration);
    }
  }, [duration, props.data]);

  useEffect(() => {
    if (props.data) {
      if (props.data.extra && !props.data.file) {
        dispatch(setVoiceOnly(true));
      } else {
        dispatch(setVoiceOnly(false));
      }
    }
  }, [props.data]);

  const handleReady = () => {
    const player = ref.current?.getInternalPlayer();
    setVideoWidth(player.videoWidth);
    setVideoHeight(player.videoHeight);
  };

  return (
    <Box
      sx={{
        overflow: "hidden",
        "& video": {
          width: videoHeight > videoWidth ? "auto !IMPORTANT" : "100%",
        },
      }}
    >
      <ReactPlayer
        className='react-player'
        ref={ref}
        width='100%'
        height='100%'
        url={url}
        pip={pip}
        playing={playing}
        light={light}
        loop={loop}
        playbackRate={playbackRate}
        volume={volume}
        muted={muted}
        onEnded={handleEnded}
        onError={handleError}
        onProgress={handleProgress}
        onDuration={handleDuration}
        onPlay={handlePlay}
        onPause={handlePause}
        onReady={handleReady}
        // Disable download button
        // playsinline
        config={{
          file: {
            attributes: {
              controlsList: "nodownload",
            },
          },
        }}
        // Disable right click
        onContextMenu={(e) => e.preventDefault()}
        // onPlaybackRateChange={handleOnPlaybackRateChange}
        // onEnablePIP={handleEnablePIP}
        // onDisablePIP={handleDisablePIP}
        // onReady={() => console.log("onReady")}
        // onStart={() => console.log("onStart")}
        // onBuffer={() => console.log("onBuffer")}
        // onSeek={(e) => console.log("onSeek", e)}
      />
    </Box>
  );
});

export default Player;
